import { render, staticRenderFns } from "./Ledger.vue?vue&type=template&id=0ce4cfbe&scoped=true&"
import script from "./Ledger.vue?vue&type=script&lang=js&"
export * from "./Ledger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce4cfbe",
  null
  
)

export default component.exports